import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { postAddProductSpecialOffer, getOfferById, updateOffer } from "../../../MyApi/product/offers";
import { toast } from "react-toastify";
import Select from "react-select"
import { getStores } from "../../../MyApi/stores";
import { getProducts } from "../../../MyApi/product";
import EnhancedSearchStore from "../../UI/enhancedstoresearch";
import EnhancedSearchProduct from "../../UI/enhancedproductsearch";
import ButtonGlobal from "../../UI/buttonGlobal";
import i18next from "i18next";
import LangSelectModal from "../../UI/langselectmodal";
import SkeletonWrapper from "../../UI/skeletonWrapper";

const OfferModal = ({ isModalOpen, toggle, offerableId, closeModal, isStore, refetch, is_flash_sale, mode = "create", offerId = null }) => {
  const isEdit = mode === "edit";
  const isShow = mode === "show";
  const lang = i18next.language;
  const [selectedLangCode, setSelectedLangCode] = useState(lang);

  const { data: offerData, isLoading: offerLoading } = useQuery(
    ["offer", offerId, selectedLangCode],
    () => getOfferById(offerId),
    {
      enabled: (isEdit || isShow) && !!offerId,
    }
  );

  const [formData, setFormData] = useState({
    stock_limit: "",
    start_date: "",
    end_date: "",
    offerable_id: offerableId,
    offerable_type: "product",
    discount_amount: "",
    discount_type: "fixed",
    status:"active",
    store_id:"",
    offerable:{},
    is_flash_sale:0
  });

  useEffect(()=>{
    setFormData((prev)=>({...prev ,is_flash_sale: is_flash_sale?1:0}))
  },[])

  useEffect(() => {
    if ((isEdit || isShow) && offerData?.data?.offer) {
      const offer = offerData.data.offer;
      setFormData({
        stock_limit: offer.stock_limit || "",
        start_date: offer.start_date ? offer.start_date.split(" ")[0] : "",
        end_date: offer.end_date ? offer.end_date.split(" ")[0] : "",
        offerable_id: offer.offerable_id || offerableId,
        offerable_type: offer.offerable_type || "product",
        discount_amount: offer.discount_amount || "",
        discount_type: offer.discount_type || "fixed",
        status: offer.status || "active",
        store_id: offer.offerable.store.id || "",
        offerable:offer.offerable ||{},
        is_flash_sale: offer.is_flash_sale || (is_flash_sale ? 1 : 0)
      });
    } else if (mode === "create") {
      setFormData({
        stock_limit: "",
        start_date: "",
        end_date: "",
        offerable_id: offerableId,
        offerable_type: "product",
        discount_amount: "",
        discount_type: "fixed",
        status:"active",
        store_id:"",
        is_flash_sale: is_flash_sale ? 1 : 0
      });
    }
  }, [isEdit, isShow, offerData, mode, offerableId, is_flash_sale]);

console.log('is_flash_sale', is_flash_sale)
  const mutation = useMutation({
    mutationKey: ["postoffer"],
  mutationFn: (postData)=>postAddProductSpecialOffer(postData),
    onSuccess: (data) => {
      toast.success(data.message || "تم إضافة العرض بنجاح");
      closeModal();
      refetch()
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حصل خطأ");
    },
  });

  const updateMutation = useMutation({
    mutationKey: ["updateoffer"],
    mutationFn: (postData) => updateOffer(offerId, postData),
    onSuccess: (data) => {
      toast.success(data.message || "تم تحديث العرض بنجاح");
      closeModal();
      refetch()
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حصل خطأ");
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const setStoreId =(id)=>{
    setFormData((prev) => ({
      ...prev,
      store_id: id,
    }));
  }
   const setProductId =(id)=>{
    setFormData((prev) => ({
      ...prev,
      offerable_id: id,
    }));
  }

  const handleSubmit = () => {
    if (isEdit) {
      const submitData = { ...formData };
      submitData.lang = selectedLangCode;
      submitData._method = "PUT";
      updateMutation.mutate(submitData);
    } else {
      mutation.mutate(formData);
    }
  };

  const handleChangeLanguage = (e) => {
    setSelectedLangCode(e.target.value);
  };

  const modalTitle = isShow ? "عرض العرض" : isEdit ? "تعديل العرض" : (is_flash_sale ? "إضافة عرض سريع" : "إضافة عرض خاص");
  const buttonText = isEdit ? "تحديث" : "إضافة عرض";

  return (
    <Modal isOpen={isModalOpen} toggle={closeModal} centered size="lg" className="add">
      <ModalHeader toggle={closeModal}>{modalTitle}</ModalHeader>

      <ModalBody>
        {isEdit && <LangSelectModal handleChange={handleChangeLanguage} selectedLangCode={selectedLangCode} />}

        <div className="row add g-3">
          {isStore && (
            <>
              <div className="col-12">
                <label htmlFor="" className="form-label">المتاجر</label>
                <SkeletonWrapper isLoading={(isEdit || isShow) && offerLoading}>
                  <EnhancedSearchStore setStoreId={setStoreId} disabled={isShow} value={(isEdit ||isShow) ?{id:formData.offerable?.store.name ,name:formData.offerable?.store.name }:""} />
                </SkeletonWrapper>
              </div>

              <div className="col-12">
                <label htmlFor="" className="form-label">المنتجات</label>
                <SkeletonWrapper isLoading={(isEdit || isShow) && offerLoading}>
                  <EnhancedSearchProduct storeId={formData?.store_id} setProductId={setProductId} value={(isEdit ||isShow) ?{id:formData.offerable_id ,name:formData.offerable?.name }:""} disabled={isShow} />
                </SkeletonWrapper>
              </div>
            </>
          )}

          <div className="col-12">
            <label className="form-label">عدد مرات الإستخدام</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && offerLoading}>
              <input
                type="number"
                min={0}
                name="stock_limit"
                className="form-control"
                value={formData.stock_limit}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>

          <div className="col-md-6">
            <label className="form-label">الخصم</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && offerLoading}>
              <input
                type="number"
                min={0}
                name="discount_amount"
                className="form-control"
                value={formData.discount_amount}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>

          <div className="col-md-6">
            <label className="form-label">نوع الخصم</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && offerLoading}>
              <select
                name="discount_type"
                className="form-control"
                value={formData.discount_type}
                onChange={handleChange}
                disabled={isShow}
              >
                <option value="fixed">ثابت</option>
                <option value="percentage">نسبة</option>
              </select>
            </SkeletonWrapper>
          </div>

          <div className="col-md-6">
            <label className="form-label">تاريخ البداية</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && offerLoading}>
              <input
                type="date"
                name="start_date"
                className="form-control"
                value={formData.start_date}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>

          <div className="col-md-6">
            <label className="form-label">تاريخ النهاية</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && offerLoading}>
              <input
                type="date"
                name="end_date"
                className="form-control"
                value={formData.end_date}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>
        </div>
      </ModalBody>

      {isShow ? null : (
        <ModalFooter>
          <div className="col-2">
            <ButtonGlobal
              className="btn-primary"
              onClick={handleSubmit}
              label={buttonText}
              isLoading={isEdit ? updateMutation.isLoading : mutation.isLoading}
              disabled={isEdit ? updateMutation.isLoading : mutation.isLoading}
            />
          </div>
          <button className="btn btn-white" type="button" onClick={closeModal}>
            إلغاء
          </button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default OfferModal;
